import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('InvitedEntityFilter', InvitedEntityFilterData);

    InvitedEntityFilterData.$inject = ['KISS_INVITED_ENTITY'];

    /* @ngInject */
    function InvitedEntityFilterData(KISS_INVITED_ENTITY) {
        InvitedEntity.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort,
        };

        function InvitedEntity(invitedEntityFilterData) {
            if (!invitedEntityFilterData) {
                this.buildEmpty();
            } else {
                this.build(invitedEntityFilterData);
            }
        }

        return InvitedEntity;

        function buildEmpty() {
            this.InvitedEntityId = null;
            this.legalEntityId = null;
            this.councountryCodetry = null;
            this.statuses = _.reject(KISS_INVITED_ENTITY.invited_entity.status, s => s.value === 'DUPLICATE');
            this.email = null;
            this.lang = null;
            this.entityType = { value: null, label: 'kiss_invited_entity.type.all' };
            this.pageCriteria = {
                pageSize: KISS_INVITED_ENTITY.invited_entity.pagination.defaultPageSize,
                page: KISS_INVITED_ENTITY.invited_entity.pagination.defaultPage,
                sorts: KISS_INVITED_ENTITY.invited_entity.pagination.defaultSort,
            };
        }

        function build(invitedEntityFilterData) {
            this.InvitedEntityId = invitedEntityFilterData.InvitedEntityId || null;
            this.legalEntityId = invitedEntityFilterData.legalEntityId || null;
            this.countryCode = invitedEntityFilterData.countryCode || null;
            this.statuses = invitedEntityFilterData.statuses || [];
            this.email = invitedEntityFilterData.email || null;
            this.lang = invitedEntityFilterData.lang || null;
            this.entityType = invitedEntityFilterData.type || null;
            this.pageCriteria = {
                pageSize:
                    invitedEntityFilterData.pageSize || KISS_INVITED_ENTITY.invited_entity.pagination.defaultPageSize,
                page: invitedEntityFilterData.page || KISS_INVITED_ENTITY.invited_entity.pagination.defaultPage,
                sorts: _setSort(invitedEntityFilterData.sorts),
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return KISS_INVITED_ENTITY.invited_entity.pagination.defaultSort;
            }
            return sorts;
        }

        /**
         *
         */
        function preparBeforeSearch() {
            var clone = new InvitedEntity(this);
            clone.pageCriteria = this.pageCriteria;
            if (this.InvitedEntity) {
                clone.InvitedEntityId = this.InvitedEntity.id;
                if (this.InvitedEntity.legalEntity) {
                    clone.legalEntityId = this.InvitedEntity.legalEntity.id;
                } else {
                    clone.InvitedEntityId = this.InvitedEntity.id;
                }
            }
            clone.countryCode = this.country ? this.country.code : null;
            clone.statuses = this.statuses ? _.map(this.statuses, 'value') : null;
            clone.entityType = this.entityType ? this.entityType.value : null;
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
